import Navbar from '@/components/feature/Navbar';
import FaqHero from './components/FaqHero';
import FaqList from './components/FaqList';
import FaqContact from './components/FaqContact';
import ContactFooter from '@/pages/home/components/ContactFooter';

export default function FaqPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <FaqHero />
      <FaqList />
      <FaqContact />
      <ContactFooter />
    </div>
  );
}
